/** Public demo video (landing footer + /demo page). */
export const DEMO_LOOM_URL =
  "https://www.loom.com/share/f87440e4bea04ef5b20bd889a0010f42";

/** Loom embed URL for the on-site /demo player. */
export const DEMO_LOOM_EMBED_URL =
  "https://www.loom.com/embed/f87440e4bea04ef5b20bd889a0010f42";

/** Shared Calendly booking link (landing CTAs, header, /demo). */
export const CALENDLY_URL = "https://calendly.com/info-ccoo/30min";

/** Public dealer / marketing contact (landing footer). */
export const DEALER_PHONE_DISPLAY = "805-823-1733";
export const DEALER_PHONE_TEL = "tel:+18058231733";
export const DEALER_EMAIL = "dealers@truecorecapital.com";
